<template>
  <!-- <v-layout>
      <h1>Fixed Cost #{{$route.params.id}}</h1>
  </v-layout>-->
  <v-layout justify-center row>
    <v-flex xs12>
      <v-toolbar color="primary" dark>
        <v-toolbar-title>Loyalty Point Rewards</v-toolbar-title>
        <v-divider class="mx-3" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <v-btn
          small
          class="text-none"
          @click="$router.push('/settings/loyalty_rewards/create?external=false')"
        >Create Internal Reward</v-btn>
        <div style="width: 12px;"></div>
        <v-btn
          small
          class="text-none"
          @click="$router.push('/settings/loyalty_rewards/create?external=true')"
        >Create External Reward</v-btn>
      </v-toolbar>
    </v-flex>
    <v-flex xs12>
      <v-layout row wrap align-content-center justify-center>
        <LoyaltyRewardList
          style="width: 100%;"
          :loyaltyRewards="loyaltyPointRewards"
          :loading="loading"
          @orderChange="changeLoyaltyRewardOrder($event)"
        ></LoyaltyRewardList>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import SimpleCard from "@/components/widget/SimpleCard.vue";
import LoyaltyRewardList from "@/components/settings/loyalty/LoyaltyRewardList.vue";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

export default {
  name: "loyalty_rewards",
  components: {
    SimpleCard,
    LoyaltyRewardList
  },
  data: function() {
    return {
      loyaltyPointRewards: [],
      query: {
        search: ""
      },
      loading: true
    };
  },
  mounted: async function() {
    this.getLoyaltyRewards();
  },
  methods: {
    clear: function() {
      this.query = {
        search: ""
      };
    },
    getLoyaltyRewards: async function() {
      this.loading = true;

      try {
        let url = `${this.$store.state.apiUrl}/settings/loyalty_point_reward/getAll`;

        let response = await axios.get(url, {
          params: {}
        });

        var lpr = response.data.loyalty_point_rewards;

        lpr.sort(function(a, b) {
          return a.priority - b.priority;
        });

        this.loyaltyPointRewards = lpr;

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log("Failed to get loyalty rewards " + error);
      }
    },
    changeLoyaltyRewardOrder: async function(newOrderedList) {
      if (newOrderedList) {
        for (let i = 0; i < newOrderedList.length; i++) {
          newOrderedList[i].priority = i + 1;
        }

        let self = this;
        let url = `${this.$store.state.apiUrl}/settings/loyalty_point_reward/reorder`;
        axios({
          url: url,
          method: "post",
          data: {
            loyalty_rewards: newOrderedList.map(function(l) {
              return { id: l.id, priority: l.priority };
            })
          },
          headers: {
            "Content-Type": "text/plain"
          }
        })
          .then(function(response) {
            console.log(response.data.errors);
            if (response.data.errors) {
              self.errors = response.data.errors;
              self.showSnackbar(
                "Error changing loyalty reward order",
                "success"
              );
            } else if (response.data.error != "no_error") {
              self.showSnackbar(
                "Error changing loyalty reward order" + response.data.error,
                "success"
              );
              console.log(response.data.error);
            } else {
              self.showSnackbar("Loyalty Reward order changed", "success");
              this.loyaltyPointRewards = newOrderedList;
            }
          })
          .catch(function(error) {
            console.log(error);
            //self.showSnackbar("Network error: " + error, "error");
          });
      }
    }
  }
};
</script>
